export const margin = 6

// Z-Indexes
export const modalZIndex = 2147483646
